<router-outlet></router-outlet>
<app-footer class="footer"></app-footer>
